module.exports = __webpack_public_path__ + "static/media/Cashout.0f928544.svg";